module.exports = __webpack_public_path__ + "static/media/shoppers_drug_mart_logo.11a61391.svg";